import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { action } from 'satcheljs/lib/legacy';
import { FOLDER_MAILS_LOADED } from 'mini-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { lazyInitMailboxJunkEmailConfiguration } from 'mini-junk-email-configuration';
import { lazyPrefetchFirstN } from 'mini-mail-prefetch';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import { type TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

const FIRST_N_ROW_PREFETCH_COUNT = 10;

/**
 * Callback for table load complete
 * @param tableView the table view
 * @param isSuccessResponseClass indicates if the response is success
 * @param shouldPrefetchFirstNRows should prefetch reading-pane data for first N rows
 */
export default action('onInitialTableLoadComplete')(function onInitialTableLoadComplete(
    tableView: TableView,
    isSuccessResponseClass: boolean,
    shouldPrefetchFirstNRows: boolean = true
) {
    // Set loading state to complete
    tableView.isLoading = false;
    tableView.isInitialLoadComplete = true;

    if (shouldPrefetchFirstNRows) {
        tableView.hasErrorLoadingTable = !isSuccessResponseClass;
        if (isSuccessResponseClass && tableView.tableQuery.type !== 1) {
            // prefetch first N rows for all tables except for Search table
            lazyPrefetchFirstN.importAndExecute(tableView, FIRST_N_ROW_PREFETCH_COUNT);
        }
    }
    // Initialize MailboxJunkEmailConfiguration store when the selected folder is junk
    // This will help to identify blocked senders
    if (tableView.tableQuery.folderId === folderNameToId('junkemail')) {
        lazyInitMailboxJunkEmailConfiguration();
    }

    // trigger workflow signal
    signalWorkflowEvent(
        FOLDER_MAILS_LOADED,
        undefined,
        undefined,
        !isSuccessResponseClass ? { error: new Error('Failed to load initial mails.') } : undefined
    );
});
